import React, { useState } from 'react';
import parse from 'html-react-parser';
import {
  Bell,
  MessageSquare,
  Share2,
  ThumbsDown,
  ThumbsUp
} from 'react-feather';
import SummaryComment from './summaryComment';
import Modal from 'react-bootstrap/Modal';
import { HTMLformatter } from '../../utils/commonFunctions';
const SummaryCard = (props) => {
  const { data: x, feedbackUpdate, active, getAlerts } = props;
  const [show, setShow] = useState(false);
  return (
    <div className='insight-card'>
      <div className='level'>
        <img src={`./img/${x.aan_level}.png`} alt={x.aan_level} />
        <div>{x.aan_level} Performance</div>
      </div>
      <div className='details'>
        <div className='content'>{parse(HTMLformatter(x.inference))}</div>
        <div className='feedback'>
          <ThumbsDown
            className={`thumbs-down ${
              Object.keys(x).includes('liked') && !x.liked ? 'active' : ''
            }`}
            onClick={() => feedbackUpdate(x, false)}
          />
          <ThumbsUp
            className={`thumbs-up ${
              Object.keys(x).includes('liked') && x.liked ? 'active' : ''
            }`}
            onClick={() => feedbackUpdate(x, true)}
          />
          <span className='flex-fill'></span>
          <div style={{ position: 'relative' }}>
            <MessageSquare
              onClick={() => setShow(true)}
              style={{ position: 'relative', top: '-3px' }}
            />
            {Object.keys(x).includes('comment') && x.comment.length > 0 && (
              <span className='notification'>{x.comment.length}</span>
            )}
          </div>
          <Share2 />
          <Bell
            onClick={() => getAlerts(x.aan_level.trim())}
            className={x.aan_level === active ? 'active' : ''}
          />
        </div>
        {show && (
          <Modal
            show={show}
            onHide={() => setShow(false)}
            size='lg'
            aria-labelledby='contained-modal-title-vcenter'
            centered
          >
            <SummaryComment id={x.id} />
          </Modal>
        )}
      </div>
    </div>
  );
};

export default SummaryCard;
